import {
  currencyTypeRender,
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';

import PackageOrdersActions from './actions';
// import { calculationStatusForTable } from './slice';
import { Link } from 'react-router-dom';

export const columns = [
  {
    id: 1,
    Header: 'Order ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 2,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <Link to={`/users/${cell.value.id}`} state={{ tab: '3' }}>
          {cell.value.id}
        </Link>
      );
    }
  },
  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell.value.name} {cell.value.surname}
        </>
      );
    }
  },

  {
    id: 4,
    Header: 'Product Name',
    accessor: 'productName',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },

  {
    id: 5,
    Header: 'Price',
    accessor: 'price',
    Cell: (cell: any) => {
      return cell?.value ? usdFormatter.format(cell?.value) : '---';
    }
  },

  {
    id: 6,
    Header: 'Date Created',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell?.value)},
        <small className='text-muted'> {handleValidTime(cell?.value)}</small>
      </>
    )
  },

  {
    id: 7,
    Header: 'Start Date',
    accessor: 'dateStart',
    Cell: (cell: any) => (
      <>
        {cell.value ? (
          <>
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        ) : (
          '---'
        )}
      </>
    )
  },

  {
    id: 8,
    Header: 'Date End',
    accessor: 'dateEnd',
    Cell: (cell: any) => (
      <>
        {cell.value ? (
          <>
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        ) : (
          '---'
        )}
      </>
    )
  },

  {
    id: 9,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell.value) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              PENDING
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              {cell.row.original.shouldCalculateDirectBonus
                ? 'PAID, NO DIRECT BONUS'
                : 'PAID'}
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED BY USER
            </span>
          );
      }
    }
  }

  // {
  //   id: 10,
  //   Header: 'Actions',
  //   accessor: 'id',
  //   Cell: (cell: any) => {
  //     if (cell?.row?.original?.status === 1) {
  //       return <PackageOrdersActions {...cell} />;
  //     }
  //   }
  // }
];
